import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileNumber = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { country } = location.state || { country: { name: 'India', dialCode: '+91', flag: '🇮🇳' } };
  
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [showOtp, setShowOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp1, setOtp1] = useState('');
  const [timer, setTimer] = useState(60);
  const otpRefs = useRef([]);

  useEffect(() => {
    let interval;
    if (showOtp && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtp, timer]);

  const handleOtpChange = (text, index) => {
    const newOtp = [...otp];
    
    if (text.length > 1) {
      const digits = text.split('').slice(0, 6 - index);
      digits.forEach((digit, i) => {
        if (index + i < 6) {
          newOtp[index + i] = digit;
        }
      });
      
      const lastFilledIndex = Math.min(index + digits.length - 1, 5);
      otpRefs.current[lastFilledIndex]?.focus();
    } else {
      newOtp[index] = text;
    }
    
    setOtp(newOtp);

    if (text && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyPress = (e, index) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      
      if (!otp[index] && index > 0) {
        newOtp[index - 1] = '';
        otpRefs.current[index - 1]?.focus();
      } else if (otp[index]) {
        newOtp[index] = '';
      }
      
      setOtp(newOtp);
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join('');
//alert(enteredOtpotp1);
    if (enteredOtp!=otp1) {
      alert('Please enter the correct 6-digit OTP');
      return;
    }
    
    setLoading(true);
    setLoading(false);
    navigate('/register1', { state: { mobile: mobile, country: country.name } });
  };

  const handleResendOtp = () => {
    setTimer(60);
    alert('New OTP has been sent to your mobile');
  };

  const handleRegister = async () => {
    if (mobile.length !== 10) {
      alert('Please enter a valid 10-digit mobile number.');
      return;
    }
    
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      
      const response = await fetch('https://singlewindowsecurities.com/rest3/web_register_api', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      console.log(result);
      
      if (response.ok && result.status==0 && result.otp) {
        setOtp1(result.otp);
        setLoading(false);
        setShowOtp(true);
        alert(`OTP has been sent to +91${mobile}`);
      } else {
        alert(result.message || 'Registration failed. Please try again.');
        setLoading(false);
      }
    } catch (error) {
      alert('Failed to connect, Please try again later.');
      setLoading(false);
    }
  };

  const clearOtp = () => {
    setOtp(['', '', '', '', '', '']);
    otpRefs.current[0]?.focus();
  };

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Top Gradient Section - Dark Golden */}
      <div style={{ 
        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
        borderBottomLeftRadius: '30px', 
        borderBottomRightRadius: '30px',
        minHeight: '140px',
        boxShadow: '0 4px 20px rgba(212, 175, 55, 0.2)'
      }}>
        <div className="container py-4">
          <div className="text-center text-dark">
            <h5 className="fw-bold" style={{ letterSpacing: '1px' }}>
              {showOtp ? 'VERIFY OTP' : 'ENTER MOBILE NUMBER'}
            </h5>
            <p className="mb-0 opacity-75 text-dark">
              {showOtp 
                ? `Enter OTP sent to +91${mobile}` 
                : "We'll send a verification code to your mobile"}
            </p>
          </div>
        </div>
      </div>

      {/* Main Card - Dark Theme */}
      <div className="container" style={{ marginTop: '-40px' }}>
        <div className="card border-0 shadow-lg rounded-4" style={{ 
          background: 'rgba(20, 20, 20, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(212, 175, 55, 0.2)'
        }}>
          <div className="card-body p-4">
            {!showOtp ? (
              <>
                {/* Mobile Input Section */}
                <div className="mb-4">
                  <small className="fw-semibold d-block mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                    MOBILE VERIFICATION
                  </small>
                  <div className="input-group">
                    <span className="input-group-text" style={{ 
                      background: '#1a1a1a', 
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRight: 'none',
                      color: '#D4AF37',
                      fontWeight: 'bold'
                    }}>+91</span>
                    <input
                      type="tel"
                      className="form-control"
                      style={{
                        background: '#1a1a1a',
                        border: '1px solid rgba(212, 175, 55, 0.3)',
                        borderLeft: 'none',
                        color: '#fff'
                      }}
                      placeholder="Enter 10-digit number"
                      maxLength="10"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                    {mobile.length === 10 && (
                      <span className="input-group-text" style={{ 
                        background: '#1a1a1a', 
                        border: '1px solid rgba(212, 175, 55, 0.3)',
                        borderLeft: 'none'
                      }}>
                        <i className="fa fa-check-circle-fill" style={{ color: '#D4AF37' }}></i>
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <small style={{ color: '#888' }}>
                      <i className="fa fa-shield-check me-1" style={{ color: '#D4AF37' }}></i>
                      Secure verification
                    </small>
                    <small style={{ color: mobile.length === 10 ? '#D4AF37' : '#888' }}>
                      {mobile.length}/10
                    </small>
                  </div>
                </div>

                {/* Send OTP Button - Golden */}
                <button
                  className={`btn w-100 ${mobile.length === 10 ? 'btn-golden' : 'btn-dark-golden'}`}
                  onClick={handleRegister}
                  disabled={mobile.length !== 10 || loading}
                  style={{
                    background: mobile.length === 10 ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : '#333',
                    border: 'none',
                    color: mobile.length === 10 ? '#000' : '#888',
                    fontWeight: 'bold',
                    padding: '12px',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" style={{ color: '#000' }}></span>
                      Sending...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-send me-2"></i>
                      SEND OTP
                    </>
                  )}
                </button>
              </>
            ) : (
              <>
                {/* OTP Input Section */}
                <div className="mb-4">
                  <small className="fw-semibold d-block mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                    ENTER 6-DIGIT OTP
                  </small>
                  <div className="d-flex justify-content-between mb-3">
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                      <input
                        key={index}
                        ref={ref => otpRefs.current[index] = ref}
                        type="text"
                        className="form-control text-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          fontSize: '1.3rem',
                          fontWeight: 'bold',
                          background: '#1a1a1a',
                          border: otp[index] ? `2px solid #D4AF37` : '1px solid rgba(212, 175, 55, 0.3)',
                          color: '#D4AF37'
                        }}
                        maxLength="1"
                        value={otp[index]}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onKeyDown={(e) => handleOtpKeyPress(e, index)}
                      />
                    ))}
                  </div>

                  {/* Clear OTP Button */}
                  {otp.some(digit => digit !== '') && (
                    <div className="text-end mb-3">
                      <button 
                        className="btn btn-link p-0 small"
                        onClick={clearOtp}
                        style={{ color: '#ff4444' }}
                      >
                        Clear OTP
                      </button>
                    </div>
                  )}

                  {/* Timer and Resend */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <i className={`fa fa-clock ${timer > 0 ? 'text-golden' : 'text-danger'} me-1`} style={{ color: timer > 0 ? '#D4AF37' : '#ff4444' }}></i>
                      <small className={timer > 0 ? 'text-golden fw-semibold' : 'text-danger fw-semibold'} style={{ color: timer > 0 ? '#D4AF37' : '#ff4444' }}>
                        {timer > 0 ? `00:${timer.toString().padStart(2, '0')}` : 'OTP Expired'}
                      </small>
                    </div>
                    <button
                      className={`btn btn-link p-0 ${timer > 0 ? 'disabled' : ''}`}
                      onClick={handleResendOtp}
                      disabled={timer > 0}
                      style={{ color: timer > 0 ? '#888' : '#D4AF37' }}
                    >
                      <small className="fw-semibold">RESEND OTP</small>
                    </button>
                  </div>

                  {/* Verify Button */}
                  <button
                    className={`btn w-100 ${otp.join('').length === 6 ? 'btn-golden' : 'btn-dark-golden'}`}
                    onClick={handleVerifyOtp}
                    disabled={otp.join('').length !== 6 || loading}
                    style={{
                      background: otp.join('').length === 6 ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : '#333',
                      border: 'none',
                      color: otp.join('').length === 6 ? '#000' : '#888',
                      fontWeight: 'bold',
                      padding: '12px'
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" style={{ color: '#000' }}></span>
                        Verifying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-check-circle me-2"></i>
                        VERIFY & CONTINUE
                      </>
                    )}
                  </button>
                </div>

                {/* Edit Mobile Option */}
                <div className="text-center">
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      setShowOtp(false);
                      clearOtp();
                    }}
                    style={{ color: '#D4AF37' }}
                  >
                    <i className="fa fa-arrow-left me-1"></i>
                    Edit mobile number
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Security Info - Dark Theme */}
      <div className="container mt-3">
        <div className="card rounded-3" style={{ 
          background: 'rgba(20, 20, 20, 0.8)',
          border: '1px solid rgba(212, 175, 55, 0.15)',
          backdropFilter: 'blur(5px)'
        }}>
          <div className="card-body p-3">
            <div className="d-flex align-items-start">
              <i className="fa fa-info-circle me-2" style={{ color: '#D4AF37' }}></i>
              <div>
                <h6 className="fw-bold mb-1 small" style={{ color: '#D4AF37' }}>Why mobile verification?</h6>
                <p className="small mb-0" style={{ color: '#888' }}>
                  Mobile verification ensures account security and enables two-factor authentication for all transactions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .btn-golden {
          background: linear-gradient(145deg, #D4AF37, #B8960C);
          transition: all 0.3s ease;
        }
        .btn-golden:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(212, 175, 55, 0.3);
        }
        .btn-dark-golden {
          background: #333;
          cursor: not-allowed;
        }
        .text-golden {
          color: #D4AF37;
        }
        input:focus {
          box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
          outline: none;
        }
      `}</style>
    </div>
  );
};

export default MobileNumber;